import {Mapper} from '@s-ui/domain'

export class SeoInstantOfferStandaloneMetaInformationMapper extends Mapper {
  constructor({config, seoDataValueObjectFactory, seoDataMapper, seoLiteralMapper}) {
    super()

    this._config = config
    this._seoDataValueObjectFactory = seoDataValueObjectFactory
    this._seoDataMapper = seoDataMapper
    this._seoLiteralMapper = seoLiteralMapper
  }

  _buildCanonical = () => {
    const protocol = this._config.get('URL_PROTOCOL')
    const host = this._config.get('HOST_DOMAIN')
    const {INSTANT_OFFER_STANDALONE_PATTERN} = this._config.get('page')

    return `${protocol}${host}${INSTANT_OFFER_STANDALONE_PATTERN}`
  }

  async map({culture}) {
    const {instantOfferStandalone: instantOfferStandaloneConfig} = this._config.get('seo')
    const {H1, META_ROBOTS, TITLE} = instantOfferStandaloneConfig[culture]

    const canonical = this._buildCanonical()

    const parsedTitle = this._seoLiteralMapper.setText({text: TITLE}).map()

    const parsedH1 = this._seoLiteralMapper.setText({text: H1}).map()

    const {links, metas, scripts, title} = this._seoDataMapper
      .title(parsedTitle)
      .robots(META_ROBOTS)
      .canonical(canonical)
      .setOpenGraphData({
        title: parsedTitle,
        url: canonical
      })
      .setTwitterCardsData()
      .map()

    return this._seoDataValueObjectFactory({
      h1: parsedH1,
      head: {
        link: links,
        meta: metas,
        scripts,
        title
      }
    })
  }
}
